/** @format */

import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import {
  pagosRegistrados,
  recargarComponente,
} from "../../redux/slices/userSlice";
import { ModalFactura } from "./ModalFactura";
import axios from "axios";

export default function ModalRecibos({ showModal, closeModal, idInscripcion }) {
  const [showModalFacturas, setShowModalFacturas] = useState(false);
  const [pagos, setPagos] = useState([]);
  const dispatch = useDispatch();
  const contador = useSelector((state) => state.contador);
  const path = useSelector((state) => state.sitePath);
  useEffect(() => {
    setPagos([]);
    const obj = {
      id_inscripcion: idInscripcion,
    };
    axios
      .post(path + "/pagos_registrados.php", obj)
      .then((res) => {
        if (res.data === "Error") {
        } else {
          setPagos(res.data);
          dispatch(pagosRegistrados(res.data));
        }
      })
      .catch((error) => {
        console.log("error", error.response);
      });
  }, [idInscripcion]);
  const openModalFacturas = () => {
    setShowModalFacturas(true);
  };
  const closeModalFacturas = () => {
    setShowModalFacturas(false);
  };
  return (
    <div>
      <Modal
        show={showModal}
        onHide={closeModal}
        className='custom-modal'
      >
        <Modal.Header closeButton>
          <Modal.Title>Recibos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className='row'>
              <div className='col-md-2'>Fecha</div>
              <div className='col-md-2'>Aportación</div>
              <div className='col-md-2'>Motivo Aportación</div>
              <div className='col-md-2'>Estado</div>
              <div className='col-md-2'></div>
            </div>
            {pagos.map((pago, i) => {
              if (pago.importe_pagado == 0) {
                return <div></div>;
              } else {
                return (
                  <div
                    className='row my-4'
                    key={pago.id}
                  >
                    <div className='col-md-2'>{pago.fecha_pago}</div>
                    <div className='col-md-2'>$ {pago.importe_pagado}</div>
                    <div className='col-md-2'>{pago.motivo_pago}</div>
                    <div className='col-md-2'>
                      {pago.estado == 1 ? "ACEPTADO" : "PENDIENTE"}
                    </div>
                    {pago.estado == 1 && !pago.uuid ? (
                      <div className='col-md-2'>
                        <Button
                          variant='success'
                          onClick={openModalFacturas}
                        >
                          Facturar
                        </Button>
                        <ModalFactura
                          showModal={showModalFacturas}
                          closeModal={closeModalFacturas}
                          idPago={pago.id}
                          key={contador}
                        />
                      </div>
                    ) : (
                      <div className='col-md-2'></div>
                    )}
                  </div>
                );
              }
            })}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={closeModal}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
